import { ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { fixedIncomeMarketStatusQuery } from '../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const FixedIncomeSellButton: React.FC<ProductButtonProps<'fixedIncomeSell'>> = (props) => {
  const buttonColor: ColorTypes.Option = useBreakpointValue({
    base: 'neutral.white' as ColorTypes.Option,
    lg: 'neutral.darkest' as ColorTypes.Option,
  });
  const { data } = useRecoilQuery(fixedIncomeMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen || !props.offer.dailyLiquidity;

  const dailyLiquidityTooltip = !props.offer.dailyLiquidity
    ? 'No momento, os resgates que necessitam\nde cotação estão indisponíveis.'
    : '';

  return (
    <ApplicationButton
      {...props}
      buttonText="Resgatar"
      buttonVariant="secondary"
      buttonColor={buttonColor}
      backgroundColor="neutral.white"
      isDisabled={props.isDisabled || forceButtonDisable}
      idSelector="productIdNormalized"
      tooltip={dailyLiquidityTooltip}
    />
  );
};
